module.exports = __webpack_public_path__ + "img/shop-body.57c1d708.jpg";